/**
 * Navigation
 * Modern with backdrop blur and teal accents
 */

import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navigation = [
  { name: 'Return to India', href: '/return-to-india' },
  { name: 'Real Estate', href: '/real-estate' },
  { name: 'Blog', href: '/blog' },
  { name: 'About', href: '/about' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (href: string) => location.pathname === href;

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-border-subtle shadow-sm">
      <div className="page-container">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="text-h3 font-medium text-text-primary tracking-tight hover:text-primary-600 transition-colors">
            Anvayee
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`
                  text-small font-medium transition-colors
                  ${isActive(item.href)
                    ? 'text-primary-600'
                    : 'text-text-secondary hover:text-primary-600'
                  }
                `}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/book"
              className="text-small font-medium px-4 py-2 bg-gradient-to-br from-primary-500 to-primary-600 text-white shadow-teal hover:shadow-teal-lg hover:-translate-y-0.5 transition-all duration-200"
            >
              Book a consultation
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-text-secondary hover:text-primary-600 transition-colors"
          >
            <span className="sr-only">Menu</span>
            {isOpen ? (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden border-t border-border-subtle bg-white/95 backdrop-blur-md">
          <div className="page-container py-6 space-y-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsOpen(false)}
                className={`
                  block text-base font-medium py-2 transition-colors
                  ${isActive(item.href) ? 'text-primary-600' : 'text-text-secondary hover:text-primary-600'}
                `}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/book"
              onClick={() => setIsOpen(false)}
              className="block text-base font-medium text-primary-600 py-2"
            >
              Book a consultation
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
